import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const PhoneField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FormInput
        name={`phones.${index}.phoneType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormInput name={`phones.${index}.number`} placeholder="+44 000 000 00" />
    </FieldLayout>
  );
};
